


























import { Component, Mixins } from "vue-property-decorator";
import { ReferenceFileInformation } from "../../../../domain/document";
import { DialogMixin } from "../../../system/mixins";

@Component({
  components: {
  },
})
export default class ReferenceFileSelectDialog extends Mixins(DialogMixin) {
  data() {
    return {
      files: [] as ReferenceFileInformation[],
      openFile: null as (file: ReferenceFileInformation) => void,
    };
  }
  files: ReferenceFileInformation[];
  openFile: (file: ReferenceFileInformation) => void;

  async show(files: ReferenceFileInformation[], openFile: (file: ReferenceFileInformation) => void): Promise<void> {
    this.files = files;
    this.openFile = openFile;
    return this.showModal(async () => {
      await this.waitHidden();
    });
  }

  onSelected(selected: ReferenceFileInformation): void {
    if (!selected) {
      return;
    }
    this.openFile(selected);
  }

  cancel() {
    this.isVisible = false;
  }
}
